import { render, staticRenderFns } from "./MagicBricks.vue?vue&type=template&id=0eaa6450&scoped=true"
import script from "./MagicBricks.vue?vue&type=script&lang=js"
export * from "./MagicBricks.vue?vue&type=script&lang=js"
import style0 from "./MagicBricks.vue?vue&type=style&index=0&id=0eaa6450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eaa6450",
  null
  
)

export default component.exports